export default __webpack_public_path__ + "static/media/mi.ca59105e.png";